import React, {memo, useEffect, useState} from "react";
import {LabelTextControl} from "../index";
import {Label} from "./Label";
import { Container, StyledTextArea, StyledDisplayDiv } from './LabelTextArea.styles';

interface LabelTextProps {
    editor: any;
    value: string;
    putData: (data: string) => void;
    labelText: string;
}

const LabelTextArea = (props: LabelTextProps) => {
    const [value, setValue] = useState(LabelTextControl.DEFAULT_VALUE);
    const [hovered, setHovered] = useState(false);
    const [editing, setEditing] = useState(false);

    const handleMouseOver = () => setHovered(true);
    const handleMouseOut = () => setHovered(false);
    const handleStartEditing = () => setEditing(true);
    const handleBlur = () => {
        props.editor.trigger("process");
        setEditing(false);
    };

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(event.target.value);
        props.putData(event.target.value);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <Container>
            <Label text={props.labelText} />
            {editing ? (
                <StyledTextArea
                    value={value}
                    onPointerDown={e => e.stopPropagation()}
                    onChange={handleOnChange}
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    onBlur={handleBlur}
                    focused={true}
                    hovered={hovered}
                    autoFocus
                />
            ) : (
                <StyledDisplayDiv
                    onPointerDown={e => e.stopPropagation()}
                    onClick={handleStartEditing}
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                    hovered={hovered}
                >
                    {value}
                </StyledDisplayDiv>
            )}
        </Container>
    );
};

export default memo(LabelTextArea);
